export default __webpack_public_path__ + "static/media/tuto_kingdom_4_2x.eba88108.webp";